import PromoManager from './PromoManager'
export default PromoManager